import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { identifyInUmami, whenUmamiReady } from '../../configs/umami';
import { getAttributionContext } from '../../services/attribution/attribution';

// Asocia la sesión de Umami con el documento del usuario logueado (guardado
// en localStorage por las páginas de verificación) y le agrega el último toque
// de campaña, que el backend consulta al atribuir. Se revisa en cada cambio
// de ruta porque no hay un único punto de login centralizado en la app.
const UmamiIdentify = () => {
  const location = useLocation();
  const lastIdentifiedDoc = useRef(null);

  useEffect(() => {
    let doc = null;
    try {
      doc = localStorage.getItem('doc');
    } catch (error) {
      return;
    }
    if (!doc || doc === lastIdentifiedDoc.current) return;

    lastIdentifiedDoc.current = doc;
    whenUmamiReady()
      .then(() => identifyInUmami(doc, getAttributionContext().lastTouch))
      .then((identified) => {
        if (!identified) lastIdentifiedDoc.current = null;
      })
      .catch(() => {
        // No debe afectar la app si Umami falla o está bloqueado; se reintenta
        // en el siguiente cambio de ruta.
        lastIdentifiedDoc.current = null;
      });
  }, [location]);

  return null;
};

export default UmamiIdentify;
